/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
    empty: PropTypes.bool,
    sSpace: PropTypes.bool,
    noSpace: PropTypes.bool,
    stacked: PropTypes.bool,
    compact: PropTypes.bool,
    link: PropTypes.bool,
    active: PropTypes.bool,
};

const defaultProps = {
    ...commonDefaultProps,
    empty: false,
    sSpace: false,
    noSpace: false,
    stacked: false,
    compact: false,
    link: false,
    active: false,
};

const Container = (props) => {
    const classNames = [
        'c-container',
        props.empty ? 'c-container--empty' : '',
        props.sSpace ? 'c-container--s-space' : '',
        props.noSpace ? 'c-container--no-space' : '',
        props.stacked ? 'c-container--stacked' : '',
        props.compact ? 'c-container--compact' : '',
        props.link ? 'c-container--link' : '',
        props.active ? 'c-container--active' : '',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Container.propTypes = propTypes;

Container.defaultProps = defaultProps;

export default Container;
